import { render, staticRenderFns } from "./SubjectsDropdown.vue?vue&type=template&id=359cfc33&scoped=true&"
import script from "./SubjectsDropdown.vue?vue&type=script&lang=ts&"
export * from "./SubjectsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectsDropdown.vue?vue&type=style&index=0&id=359cfc33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359cfc33",
  null
  
)

export default component.exports